import { useCommonStore } from "@/stores";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { temp_placeholder_png } from "@/assets/images";
import { RightSvg } from "@/assets/icons";
import { Template, UploadButton } from "@/components";
import { useCustomTemp, useMediaQuery } from "@/hooks";
import { TTemplate } from "@/types";
import { useMemo } from "react";
import { isEmpty } from "lodash-es";

interface RecommendPanelProps {
  showTitle?: boolean;
  showUploadButton?: boolean;
}
const RecommendPanel = (props: RecommendPanelProps) => {
  const { showTitle = true, showUploadButton = true } = props;
  const { t } = useTranslation();

  const { handleCustomTemp } = useCustomTemp();

  const recommendTempList = useCommonStore(state => state.getters.recommendTempList);
  const setAllPresetVisible = useCommonStore(state => state.setAllPresetVisible);
  const chooseTemp = useCommonStore(state => state.chooseTemp);
  const isBook = useMediaQuery({ query: "(max-width: 1280px) and (min-width: 960px)" });
  const isPad = useMediaQuery({ query: "(max-width: 960px) and (min-width: 768px)" });

  const handleClickTemp = (temp: TTemplate) => {
    chooseTemp(temp);
  }

  const handleSelect = (files: any) => {    
    if (!isEmpty(files)) {
      const { file, url } = files[0];
      chooseTemp(file || url);
    }
  }

  const tempList = useMemo(() => {
    let length = 5;
    if (isPad) {
      length = 3;
    } else if (isBook) {
      length = 4;
    }
    return recommendTempList.slice(0, length);
  }, [isBook, isPad, recommendTempList]);

  return (
    <div
      className={styles["root"]}
    >
      {showTitle&&<div
        className={styles["title"]}
      >
        {t("recommend_panel_title")}
      </div>}

      {showUploadButton && <div
        className={styles["upload_row"]}
      >
        <img 
          className={styles["temp_placeholder"]}
          src={temp_placeholder_png}
          alt="" 
        />

        <UploadButton
          title={t("recommend_panel_upload_button")}
          onClick={handleCustomTemp}
          isShowTrigger
          onSelect={handleSelect}
        ></UploadButton>
      </div>}

      <div
        className={styles["recommend_wrap"]}
      >
        <div
          className={styles["recommend_title"]}
        >
          {t("recommend_title")}
        </div>

        <div
          className={styles["recommend_row"]}
        >
          {tempList.map(item => (
            <Template
              key={item.id}
              {...item}
              onClick={() => handleClickTemp(item)}
            ></Template>
          ))}

          <div
            className={styles["see_all_wrap"]}
          >
            <button
              className={styles["see_all_button"]}
              onClick={() => setAllPresetVisible(true)}
            >
              <RightSvg></RightSvg>
            </button>

            <span
              className={styles["see_all"]}
            >
              {t("see_all")}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecommendPanel;